module.exports = __webpack_public_path__ + "c2e86b3635623af98b4b5368aa7fa439.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/Age4Logo.jpg
// module id = 454
// module chunks = 0